import { USER_ROLE } from "@/shared/types/route.ts";
import { Navigate, Outlet } from "react-router-dom";
import { useSession } from "@/auth/contexts/auth-context.tsx";

interface IProps {
  roles: USER_ROLE[];
}

const ProtectedRoute = ({ roles }: IProps) => {
  const { accessToken } = useSession();

  return <Outlet /> ;
};

export default ProtectedRoute;
